import React from 'react';
import {
  Box,
  Avatar,
  Typography,
  Chip,
  Tooltip,
  Divider,
  useTheme,
} from '@mui/material';
import {
  ArrowUpward,
  ArrowDownward,
  AccountBalance,
} from '@mui/icons-material';
import { Transaction } from '../../types/plaid';

interface TransactionItemProps extends Pick<Transaction, 'id' | 'accountId' | 'amount' | 'merchantName' | 'date' | 'type'> {
  showDivider?: boolean;
}

const TransactionItem: React.FC<TransactionItemProps> = ({
  id,
  accountId,
  amount,
  merchantName,
  date,
  type,
  showDivider = true,
}) => {
  const theme = useTheme();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{
              bgcolor: type === 'DEPOSIT' ? 'success.light' : 'error.light',
              boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
            }}
          >
            {type === 'DEPOSIT' ? <ArrowUpward /> : <ArrowDownward />}
          </Avatar>
          <Box>
            <Typography variant="subtitle2" sx={{ color: theme.palette.text.primary }}>
              {merchantName || 'Unknown Merchant'}
            </Typography>
            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
              {new Date(date).toLocaleDateString()}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ textAlign: 'right' }}>
            <Typography
              variant="subtitle2"
              sx={{
                color: type === 'DEPOSIT' ? theme.palette.success.main : theme.palette.error.main,
                fontWeight: 600,
              }}
            >
              {type === 'DEPOSIT' ? '+' : '-'}${Math.abs(amount).toFixed(2)}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
              <Tooltip title="Account">
                <Chip
                  size="small"
                  icon={<AccountBalance sx={{ fontSize: 14 }} />}
                  label={`Account ${accountId}`}
                  sx={{ height: 20, '& .MuiChip-icon': { fontSize: 14 } }}
                />
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </Box>
      {showDivider && <Divider />}
    </>
  );
};

export default TransactionItem; 